
/**
 * Cargo.
 */
export class Cargo {
	id?: number;
	nomeCargo?: string;
	codigoCargo?: number;
	idQuestionario?: number;
	idConcurso?: number;
	codigoOrgao?: number;
	dataInicioLiberacao?: string;
	dataFimLiberacao?: string;
	situacao?: string;

	constructor(id?: number, nomeCargo?: string, codigoCargo?: number, idQuestionario?: number, idConcurso?: number, codigoOrgao?: number, dataInicioLiberacao?: string, dataFimLiberacao?: string, situacao?: string) {
		this.id = id;
		this.nomeCargo = nomeCargo;
		this.codigoCargo = codigoCargo;
		this.idQuestionario = idQuestionario;
		this.idConcurso = idConcurso;
		this.codigoOrgao = codigoOrgao;
		this.dataInicioLiberacao = dataInicioLiberacao;
		this.dataFimLiberacao = dataFimLiberacao;
		this.situacao = situacao;
	}
}
